import React, { useEffect, useState } from 'react';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row } from '../../../Component';
import TextInput from '../../../../pages/components/inputs/TextInput';
import { useDispatch } from 'react-redux';

const initialState = { sms_provider: "", sms_sender_id: "", password: "", smpp_host: "", smpp_port: "", system_id: "", system_type: "" };

const AdminAddTenantSMSProviderModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

 const [open, setOpen] = useState(isOpen);
 const [page_data, setPageData] = useState([]);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const [sent_data, setSentData] = useState(data);
 const [form_data, setFormData] = useState(initialState);

 useEffect(() => {
  setError("");
  setSentData(data);
  setOpen(isOpen);
 }, [isOpen, data]);

 const handleAddSmsCredentials = () => {
  setError("");

 };

 return (
  <>
   <Modal isOpen={open} className="modal-dialog-centered" size={"md"}>
    <ModalHeader toggle={!loading && closeModal}>Add Bulk SMS Provider Settings</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      <TextInput
       label="SMS Provider"
       type="text"
       required
       id_val="sms_provider"
       value={form_data?.sms_provider}
       colSize="6"
       name="sms_provider"
       handleChange={(e) => setFormData({ ...form_data, ["sms_provider"]: e.target.value })}
      />
      {
       form_data?.sms_provider?.toLowerCase() === "zamtel" && (
        <>
         <TextInput
          label="Sender ID"
          type="text"
          required
          id_val="sms_sender_id"
          value={form_data?.sms_sender_id}
          colSize="6"
          name="sms_sender_id"
          handleChange={(e) => setFormData({ ...form_data, ["sms_sender_id"]: e.target.value })}
         />
         <TextInput
          label="API Key"
          type="password"
          required
          id_val="sender_api_key"
          value={form_data?.password}
          colSize="6"
          name="sender_api_key"
          handleChange={(e) => setFormData({ ...form_data, ["password"]: e.target.value })}
         />
        </>
       )
      }
      {
       form_data?.sms_provider?.toLowerCase() === "mtn" && (
        <>
         <TextInput
          label="Smpp Host"
          type="text"
          required
          id_val="smpp_host"
          value={form_data?.smpp_host}
          colSize="6"
          name="smpp_host"
          handleChange={(e) => setFormData({ ...form_data, ["smpp_host"]: e.target.value })}
         />
         <TextInput
          label="Smpp Port"
          type="text"
          required
          id_val="smpp_port"
          value={form_data?.smpp_port}
          colSize="6"
          name="smpp_port"
          handleChange={(e) => setFormData({ ...form_data, ["smpp_port"]: e.target.value })}
         />
         <TextInput
          label="System ID"
          type="text"
          required
          id_val="system_id"
          value={form_data?.system_id}
          colSize="6"
          name="system_id"
          handleChange={(e) => setFormData({ ...form_data, ["system_id"]: e.target.value })}
         />
         <TextInput
          label="System Type"
          type="text"
          required
          id_val="system_type"
          value={form_data?.system_type}
          colSize="6"
          name="system_type"
          handleChange={(e) => setFormData({ ...form_data, ["system_type"]: e.target.value })}
         />
         <TextInput
          label="Password"
          type="text"
          required
          id_val="password"
          value={form_data?.password}
          colSize="6"
          name="password"
          handleChange={(e) => setFormData({ ...form_data, ["password"]: e.target.value })}
         />
        </>
       )
      }

      {error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {error}{" "}
        </Alert>
       </div>
      )}
      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
       <Button
        onClick={handleAddSmsCredentials}
        disabled={loading ||
         form_data?.sms_provider?.toLowerCase() === "mtn" ? !(form_data?.sms_provider?.trim() &&
          form_data?.password?.trim() &&
          form_data?.smpp_port?.trim() &&
          form_data?.smpp_host?.trim() &&
          form_data?.system_id?.trim() &&
          form_data?.system_type?.trim() &&
          form_data?.password?.trim())
         :
         !(form_data?.sms_provider?.trim() &&
          form_data?.sms_sender_id?.trim() &&
          form_data?.password?.trim())}
        color="primary"
       >
        {loading ? <Spinner size="sm" color="light" /> : "Add SMS Credentials"}
       </Button>
      </Col>
     </Row>
    </ModalBody>
   </Modal>
  </>
 );
};

export default AdminAddTenantSMSProviderModal;